/*  MUI  */
import { Grid } from '@mui/material';

/* Shared */
import { UserActionsCard } from 'application/Shared/Components/UserActionsCard';

/*  React  */
import React from 'react';

/* Internal Components */
import { UserAccountTable } from './Details/UserAccountTable';
import { UserActiveAppsCard } from './Details/UserActiveAppsCard';
import { UserAliasesBrowsersCard } from './Details/UserAliasesBrowsersCard';
import { UserAppsTable } from './Details/UserAppsTable';
import { UserTotalAccountsCard } from './Details/UserTotalAccountsCard';
import { UserTotalAppsCard } from './Details/UserTotalAppsCard';

export const UserOverview = () => (
    <Grid
        container
        spacing={3}
        alignItems="stretch"
        data-testid="adminUserOverview"
    >
        <Grid item xs={12} sm={6}>
            <UserActionsCard />
        </Grid>

        <Grid item xs={12} sm={6} style={{ minHeight: '218px' }}>
            <UserAliasesBrowsersCard />
        </Grid>
        <Grid item xs={12}>
            <UserAccountTable />
        </Grid>
        <Grid item xs={4}>
            <UserTotalAppsCard />
        </Grid>
        <Grid item xs={4}>
            <UserTotalAccountsCard />
        </Grid>
        <Grid item xs={4}>
            <UserActiveAppsCard />
        </Grid>
        <Grid item xs={12}>
            <UserAppsTable />
        </Grid>
    </Grid>
);
